import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { closeModal, selectActiveModalData } from 'features/modal/modalSlice';
import { useTranslation } from 'react-i18next';
import { kickUsers } from 'features/users/actions';
import { PermissionTypes } from 'features/permissions/types';
import { usePermissions } from 'features/permissions/usePermissions';
import { selectLocalUserRole } from 'features/users/usersSlice';
import ConfirmationDialog from 'components/ConfirmationDialog';

const KickUsersConfirmation = () => {
  const { t } = useTranslation('modals');
  const dispatch = useAppDispatch();

  const modalData = useAppSelector(selectActiveModalData);
  const role = modalData.role as string;
  const displayRoleName = modalData.displayRoleName.toLowerCase() as string;

  const { hasPermissions } = usePermissions();

  const canRemoveParticipant = hasPermissions(PermissionTypes.removeParticipant, {
    targetRole: role,
  });

  const localRole = useAppSelector(selectLocalUserRole);

  useEffect(() => {
    if (!canRemoveParticipant || localRole === role) {
      dispatch(closeModal('kickUsersConfirmation'));
    }
  }, [canRemoveParticipant, localRole, role, dispatch]);

  const handleOk = () => {
    dispatch(kickUsers(role));
    dispatch(closeModal('kickUsersConfirmation'));
  };

  const handleCancel = () => {
    dispatch(closeModal('kickUsersConfirmation'));
  };

  return (
    <ConfirmationDialog
      open
      title={t('kick_users_confirm.title', { role: displayRoleName })}
      description={t('kick_users_confirm.description', { role: displayRoleName })}
      cancelText={t('kick_users_confirm.btn_cancel_label')}
      okText={t('kick_users_confirm.btn_ok_label')}
      onOk={handleOk}
      onCancel={handleCancel}
    />
  );
};

export default KickUsersConfirmation;
